export default __webpack_public_path__ + "static/media/pinIcon.575ca26b.svg";